import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError, from } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const oauthService = inject(OAuthService);
  const router = inject(Router);

  const authToken = oauthService.getAccessToken();
  const currentUrl = router.url;

  const authReq = req.clone({
    headers: req.headers.set('Authorization', 'Bearer ' + authToken)
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (
          !currentUrl.includes('/signin') &&
          !router.url.includes('procurement/suppliers-office/procurement-list')
        ) {
          return from(oauthService.refreshToken()).pipe(
            switchMap(() => {
              const newAuthToken = oauthService.getAccessToken();
              const retryRequest = req.clone({
                headers: req.headers.set(
                  'Authorization',
                  'Bearer ' + newAuthToken
                )
              });
              return next(retryRequest);
            }),
            catchError(() => {
              oauthService.logOut();
              router.navigate(['/signin']);
              return throwError(() => new Error('Token refresh failed.'));
            })
          );
        }
      } else if (error.status === 403) {
        sessionStorage.setItem(
          'lastVisitedUrlBefore403',
          router.url.split('/').slice(0, -1).join('/')
        );
        router.navigate(['/not-access']);
      }
      return throwError(() => error);
    })
  );
};
